import queryString from 'query-string'

import { OptimiseProgramme } from 'src/types/tracking'
import { report } from 'utils/logging/logging'

export const OPTIMISE_SSKEY = 'optimise-sskey'
export const OPTIMISE_AFFILIATE_PROGRAMME_KEY = 'optimise-programme'

const OPTIMISE_SSKEY_QUERY_PARAM_NAME = 'sskey'
const OPTIMISE_AFFILIATE_PROGRAMME_QUERY_PARAM_NAME = 'optimise_programme'

export const persistOptimiseTrackingDataInSession = (query: queryString.ParsedQuery<string>) => {
  const optimiseSsKey = query[OPTIMISE_SSKEY_QUERY_PARAM_NAME]
  const optimiseProgramme = query[OPTIMISE_AFFILIATE_PROGRAMME_QUERY_PARAM_NAME]

  if (Array.isArray(optimiseSsKey) || Array.isArray(optimiseProgramme)) {
    report(new Error(), 'Unexpected Optimise sskey or optimise_programme from query params')
    return
  }

  if (optimiseSsKey) {
    sessionStorage.setItem(OPTIMISE_SSKEY, optimiseSsKey)

    if (optimiseProgramme) {
      sessionStorage.setItem(OPTIMISE_AFFILIATE_PROGRAMME_KEY, optimiseProgramme)
    }
  }
}

const isValidOptimiseProgramme = (
  optimiseProgramme: string | null,
): optimiseProgramme is OptimiseProgramme => {
  const isValid = Object.values(OptimiseProgramme).includes(optimiseProgramme as OptimiseProgramme)

  if (!isValid) {
    report(new Error(), 'Retrieved Optimise programme type does not match the ProgrammeType enum', {
      args: { optimiseProgramme },
    })
  }

  return isValid
}

export const retrieveOptimiseTrackingDataFromSession = () => {
  const optimiseProgramme = sessionStorage.getItem(OPTIMISE_AFFILIATE_PROGRAMME_KEY)

  const validatedOptimiseProgramme =
    optimiseProgramme && isValidOptimiseProgramme(optimiseProgramme) ? optimiseProgramme : null

  return {
    sskey: sessionStorage.getItem(OPTIMISE_SSKEY),
    optimiseProgramme: validatedOptimiseProgramme,
  }
}

export const removeOptimiseTrackingDataInSession = () => {
  const optimiseProgramme = sessionStorage.getItem(OPTIMISE_AFFILIATE_PROGRAMME_KEY)
  const sskey = sessionStorage.getItem(OPTIMISE_SSKEY)

  if (sskey) {
    sessionStorage.removeItem(OPTIMISE_SSKEY)
  }
  if (optimiseProgramme) {
    sessionStorage.removeItem(OPTIMISE_AFFILIATE_PROGRAMME_KEY)
  }
}
